// src/theme/minimalTheme.js
// ─────────────────────────────────────────────────────────────────────────
// Central design tokens for the minimal redesign.
// Direction: dark cool ground, ONE orange accent used sparingly, thin marks,
// muted neutrals, minimal chart-junk. Single source of truth so Recharts and
// Chart.js surfaces stay consistent. See docs / design concept for rationale.
// ─────────────────────────────────────────────────────────────────────────

export const colors = {
  bg: "#0b0c0e",
  panel: "rgba(255,255,255,0.016)",
  ink: "#ececee",
  ink2: "#c7c8cc",
  dim: "#82858f",
  faint: "#54565e",
  line: "rgba(255,255,255,0.08)",
  line2: "rgba(255,255,255,0.045)",
  accent: "#ff1026", // the single accent — use sparingly (us / highlighted value)
  track: "rgba(255,255,255,0.07)",
  barMute: "rgba(255,255,255,0.16)", // opponent / non-highlighted marks
  // semantic status — ALWAYS ship with a text label (win/lose are hard to tell
  // apart under red-green colour blindness; never encode by colour alone).
  win: "#10b981",
  lose: "#f43f5e",
  warn: "#ffb020",
};

export const fonts = {
  sans: "'Kanit', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  mono: "ui-monospace, 'SF Mono', 'JetBrains Mono', Menlo, monospace",
};

export const space = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 };
export const radius = { sm: 8, md: 14, lg: 20 };

// Recharts primitives — spread onto <CartesianGrid>, tick={...}, <Legend wrapperStyle>.
export const chart = {
  grid: { strokeDasharray: "2 7", stroke: "rgba(255,255,255,0.06)" },
  axisTick: { fill: colors.dim, fontSize: 11, fontWeight: 500, fontFamily: fonts.sans },
  legend: { color: colors.dim, fontSize: 12, fontFamily: fonts.sans, paddingTop: 10 },
  // series roles
  us: colors.accent,
  opp: colors.barMute,
};

// Chart.js: call once at app init to align the react-chartjs-2 surfaces.
export function applyChartJsDefaults(ChartJS) {
  if (!ChartJS || !ChartJS.defaults) return;
  ChartJS.defaults.color = colors.dim;
  if (ChartJS.defaults.font) ChartJS.defaults.font.family = "Kanit, system-ui, sans-serif";
  ChartJS.defaults.borderColor = colors.line;
}

const minimalTheme = { colors, fonts, space, radius, chart, applyChartJsDefaults };
export default minimalTheme;
